import * as React from 'react';
import { Box } from '@mui/material';
import { ChatContainerProps } from './types';

export const ChatContainer = React.forwardRef<HTMLDivElement, ChatContainerProps>(({ children }, ref) => {
	return (
		<Box
			sx={{
				flex: 1,
				overflowY: 'auto',
				p: 1.5,
				bgcolor: 'grey.50',
				minHeight: 0,
				display: 'flex',
				flexDirection: 'column',
				mb: 2,
			}}
		>
			<Box ref={ref} sx={{ flex: 1, overflowY: 'auto' }}>
				{children}
			</Box>
		</Box>
	);
});

ChatContainer.displayName = 'ChatContainer';
